import React from "react";
import Header from "./Components/Header";
import TodoConatiner from "./Components/TodoConatiner";

function App() {
  return (
    <section className='App'>
      <Header />
      <TodoConatiner />
    </section>
  );
}

export default App;
